import { config } from "../../config"

export const game_management = {
  readAll: () => {
    const base = config.apiUrl + `/games/manage`,
      opt = {}

    return { url: base, opt }
  },

  create: ({ token, game }) => {
    const url = config.apiUrl + `/games/manage`,
      opt = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(game),
      }

    return { url, opt }
  },

  update: ({ token, id, game }) => {
    const url = config.apiUrl + `/games/manage/${id}`,
      opt = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(game),
      }

    return { url, opt }
  },

  delete: ({ token, id }) => {
    const url = config.apiUrl + `/games/manage/${id}`,
      opt = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }

    return { url, opt }
  },
}
